import React, { useEffect, useRef } from "react";
import { useCookie } from "../../context/CookieProvider";
import { useLocation } from "react-router-dom";
import { useAccount } from "../../context/AccountProvider";
import { useParty } from "../../context/PartyProvider";
import { useAnalytics } from "../../context/AnalyticsProvider";

const ScriptLoader = () => {
  const { getCookie } = useCookie();
  const location = useLocation();
  const { useGetAccount } = useAccount();
  const { account } = useGetAccount();
  const { useGetParty } = useParty();
  const { party } = useGetParty();
  const { tag, setTag } = useAnalytics();

  const postedPages = useRef(new Set());

  useEffect(() => {
    const consent = getCookie("google_analytics");

    const debtorId = account?.debtorId;
    const accountReference = account?.accountReference;
    const accountId = account?.accountId;
    const partyId = party?.partyId;
    const path = location.pathname;

    console.log("[Analytics] Consent:", consent);
    console.log("[Analytics] Page:", path);
    console.log("[Analytics] Payload check:", {
      accountReference,
      accountId,
      partyId,
      debtorId,
      tag,
    });

    if (
      !debtorId ||
      !accountReference ||
      !accountId ||
      !partyId ||
      postedPages.current.has(path)
    ) {
      return;
    }

    postedPages.current.add(path);

    const sendAnalyticsToBackend = async () => {
      const payload = {
        accountReference,
        accountId,
        partyId,
        eventType: "page_view",
        path,
        ...(tag && { tag }),
      };

      try {
        const res = await fetch("/api/analytics", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        const data = await res.json();
        console.log("✅ Analytics POST success:", data);
      } catch (error) {
        console.error("❌ Analytics POST error:", error);
      }

      // Clear tag after sending to backend
      if (tag) setTag(null);
    };

    sendAnalyticsToBackend();

    if (consent === "accepted") {
      if (!window.dataLayer) window.dataLayer = [];

      const gtag = (...args) => window.dataLayer.push(args);

      if (!document.getElementById("gtag-js")) {
        const gaScript = document.createElement("script");
        gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-GC0GN8WQPK";
        gaScript.async = true;
        gaScript.id = "gtag-js";
        document.head.appendChild(gaScript);

        gaScript.onload = () => {
          gtag("js", new Date());
          gtag("consent", "update", { analytics_storage: "granted" });
          gtag("config", "G-GC0GN8WQPK");
          gtag("event", "sfs_debtor_id", { debtorId });

          console.log("✅ GA event sent for page:", path);
        };
      }

      if (!document.getElementById("gtm-js")) {
        const gtmScript = document.createElement("script");
        gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=GTM-MKVPQH6N";
        gtmScript.async = true;
        gtmScript.id = "gtm-js";
        document.head.appendChild(gtmScript);
      }
    }
  }, [getCookie, account, party, location, tag, setTag]);

  return null;
};

export default ScriptLoader;
